import IncomeAndAssets from "./IncomeAndAssets";

export default IncomeAndAssets;
